/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ClaimsSchemaEnumValue: core.serialization.ObjectSchema<
    serializers.ClaimsSchemaEnumValue.Raw,
    Truvity.ClaimsSchemaEnumValue
> = core.serialization.object({
    title: core.serialization.string().optional(),
    value: core.serialization.string(),
});

export declare namespace ClaimsSchemaEnumValue {
    export interface Raw {
        title?: string | null;
        value: string;
    }
}
